import { Storage } from '@trello/storage';
import {
  featureFlagClient,
  FlagSet,
  FX3_EVALUATIONS_FLAG,
} from '@trello/feature-flag-client';

const FEATURE_FLAGS_KEY = 'featureFlagSnapshot';

// Exclude entries with false values from the recorded
// flags
function filterFlags(flags: FlagSet): Partial<FlagSet> {
  return Object.entries(flags)
    .filter(([key, value]) => value)
    .reduce((combined: FlagSet, [key, value]) => {
      combined[key] = value;

      return combined;
    }, {});
}

function writeFlagsToLocalStorage() {
  const { remote, overrides } = featureFlagClient.all();

  Storage.set(FEATURE_FLAGS_KEY, {
    remote: filterFlags(remote),
    overrides: filterFlags(overrides),
  });
}

export async function recordFeatureFlags() {
  // Wait for the initial load of feature flags and write to local storage
  await featureFlagClient.ready();
  writeFlagsToLocalStorage();

  featureFlagClient.client.on('change', () => {
    // Early return if we are evaluating using fx3, so we don't accidently blast away the
    // featureFlagSnapshot with an empty set of flags
    if (featureFlagClient.client.variation(FX3_EVALUATIONS_FLAG, false)) {
      return;
    }

    writeFlagsToLocalStorage();
  });

  featureFlagClient.atlassianClient.onAnyFlagUpdated(() => {
    // Early return if we are _not_ evaluating using fx3, so we don't write values that
    // aren't necessarily accurate
    if (!featureFlagClient.client.variation(FX3_EVALUATIONS_FLAG, false)) {
      return;
    }

    writeFlagsToLocalStorage();
  });
}
